import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterRelatorioConsumoItensContrato(filtro) {
        let url = `${api}/gescon/contrato/relatorios/consumo-itens?CodigoContrato=${encodeURIComponent(
            filtro.contrato ? filtro.contrato : ''
        )}`

        return axiosJwt
            .get(url, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
